import React, { useState } from "react";
import useCloudfrontImage from "../utils/useCloudfrontImage";

let { appname } = window.app;

// Full-panel loader used while a screen is fetching its data. It always
// renders something: the branded SVG once the image host is known, and a CSS
// spinner until then (or if the SVG fails), so a page is never blank or
// showing an empty image box while it waits.
const Loader = () => {
    const image = useCloudfrontImage();
    const [imageFailed, setImageFailed] = useState(false);

    return (
        <div className="orasi-preloader">
            {image && !imageFailed ? (
                <img
                    src={`${image}${appname}/images/web/Loader.svg`}
                    alt=""
                    onError={() => setImageFailed(true)}
                />
            ) : (
                <span className="spot-loader-spinner" role="status" aria-label="Loading" />
            )}
        </div>
    );
};

export default Loader;
